<template>
    <div>
        <div v-if="count > 1 && loaded" class="mb-2">
            <div>
                <p class="font-sm text-elev-blue-dim mb-2"><strong>{{ $t('Lærer') }}</strong></p>
                <select name="teacher-select" class="form-select" v-model="id" @change="select">
                    <option value="0">{{ $t('Alle') }}</option>
                    <optgroup v-for="group in list" :label="group.name">
                        <option v-for="(teacher, i) in group.list" :value="teacher.user_id" :selected="id == teacher.user_id">{{ teacher.full_name }}</option>
                    </optgroup>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import Api from '../../api/User'
import Store from '../../state/calendarStore'

const emits = defineEmits(['loaded', 'change'])

const id = ref(null)
const name = ref(null)
const count = ref(1)
const loaded = ref(false)

const list = ref([
    {
        name: $t('Hovedlærer'),
        list: [],
    },
    {
        name: $t('Lærere'),
        list: [],
    }
])

// Computed
const selectedTeacherId = computed(() => Store.state.teacherId)

// Methods
function select() {
    emits('change', id.value)
}

// Initialize data
onMounted(() => {
    Api.TeacherList().then(res => {
        if (!res.data.mainTeacherId) {
            // Auto select 0 option
            res.data.mainTeacherId = 0
            list.value = [
                {
                    name: $t('Lærere'),
                    list: [],
                }
            ]
            list.value[0].list = res.data.teacherList
        } else {
            list.value[0].list.push(res.data.teacherList.shift())
            list.value[1].list = res.data.teacherList
        }
        
        count.value = res.data.count
        id.value = res.data.mainTeacherId
        loaded.value = true

        emits('loaded')
        
        if (count.value === 1 && id.value === 0) {
            id.value = res.data.teacherList[0].user_id
            select()
        } else {
            Store.state.teacherId = res.data.mainTeacherId
        }
    })
})

// Watch
watch(() => selectedTeacherId.value, (val) => {
    if (val !== id.value) {
        id.value = val
    }
})
</script>
